<template>
  <div class="f-notification-space">
    <transition-group name="toasts">
      <div v-for="toast in toasts" :key="toast._key">
        <vue-placeholder
          :component="toast.component"
          :handler="handler"
          @action="() => toast.remove()"
          @remove="() => toast.remove()"
        ></vue-placeholder>
      </div>
      <!-- <f-invalid-session key="invalid session"></f-invalid-session> -->
    </transition-group>

    <f-fade-transition>
      <f-items-progressing
        v-if="uploadsOpened"
        name="Uploading"
        :items="progressItems"
        @close="uploadsOpened = false"
      ></f-items-progressing>
    </f-fade-transition>

    <div class="big-sticky" v-if="bigStickies[0]">
      <vue-placeholder
        :key="bigStickies[0]._key"
        :component="bigStickies[0].component"
        :handler="handler"
        @remove="bigStickies[0].remove()"
        @action="bigStickies[0].remove()"
      ></vue-placeholder>
    </div>
  </div>
</template>
<script>
import notificationService from "/vodalys/vnotification/vnotification.service.mjs";
export default {
  props: ["handler"],
  data() {
    return {
      toasts: notificationService._toasts,
      progressItems: notificationService._progressItems,
      bigStickies: notificationService._bigStickies,
      uploadsOpened: false,
    };
  },
  computed: {
    hasProgressItems() {
      return this.progressItems && this.progressItems.length > 0;
    },
  },
  watch: {
    hasProgressItems(n, o) {
      if (!o && n) {
        this.uploadsOpened = true;
      }
    },
  },
};
</script>
<style lang="scss">
.f-notification-space,
.f-notification-space > span {
    background-color: rgba(255, 192, 203, 0.5);
  overflow: hidden;
  visibility: hidden;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px;

  text-align: initial;

  gap: 8px;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  .toasts-enter-active,
  .toasts-leave-active {
    transition: all 200ms;
  }
  .toasts-enter, .toasts-leave-to /* .toasts-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }

  > * {
    visibility: visible;
  }

  .f-items-progressing {
    position: absolute;
    right: 32px;
    bottom: 32px;
  }
}
</style>
